import Vue from 'vue';

import Vue2Filters from 'vue2-filters';
import PrDateFilter from './PrDateFilter';
import PrDateTimeFilter from './PrDateTimeFilter';
import PrTimeFilter from './PrTimeFilter';
import TAttr from './TAttrFilter';
import CurrencyFilter from './CurrencyFilter';
import PrCnpjFilter from './PrCnpjFilter';
import ConvertToByte from './ConvertToByte';

/**
 * Encapsula todos os filtros globais utilizados no sistema
 * Filtros criados e plugins especificos de filtros
 */
Vue.filter('prCnpj', PrCnpjFilter);
Vue.filter('prDate', PrDateFilter);
Vue.filter('prDateTime', PrDateTimeFilter);
Vue.filter('prTime', PrTimeFilter);
Vue.filter('tAttr', TAttr);
Vue.filter('prCurrency', CurrencyFilter);
Vue.filter('convertToByte', ConvertToByte);


Vue.use(Vue2Filters);




// WEBPACK FOOTER //
// ./src/filters/index.js